<template>
  <div class="content-box">
    <!--    上方盒子-->
    <div class="father-box" ref="topBox">
      <el-card class="top-card" style="height: 100%">
        <div class="car-box">
          <el-row>
            <span>终端信息</span>
          </el-row>
          <el-form :inline="true" :model="formQuery" class="demo-form-inline">
            <el-form-item label="终端IMEI号 : ">
              <el-input v-model="formQuery.vin" size="mini" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="终端工作状态 : ">
              <el-select v-model="formQuery.terminalWorkStatus" size="mini" placeholder="请选择">
                <el-option
                    v-for="item in terminalWorkStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button @click="search()" type="primary" size="mini">查询</el-button>
              <el-button @click="reset()" size="mini">重置</el-button>
              <el-button @click="templateDownload()" size="mini">模板下载</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="padding-box">
          <el-table
              class="tableListValue"
              ref="tableRef"
              :data="tableData"
              stripe
              style="width: 100%;overflow-y: auto; height: 600px;">
            <el-table-column label="序号" prop="id" type="index" width="60" align="center">
            </el-table-column>
            <el-table-column
                align="center"
                prop="vin"
                label="终端IMEI号">
            </el-table-column>
            <el-table-column
                align="center"
                prop="onlineStatus"
                label="终端工作状态">
              <template slot-scope="scope">
                {{ onlineStatusObj[scope.row.onlineStatus] }}
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                prop="powerOnTime"
                label="最近一次终端上电时间">
              <template slot-scope="scope">
                {{ scope.row.powerOnTime || '-' }}
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="操作">
              <template slot-scope="scope">
<!--                <button @click="idInput(scope.row)">ID导入</button>-->
                <el-upload
                    class="upload-demo"
                    action="##"
                    :http-request="uploadExcelFile"
                    :before-upload="file => beforeUpload(file, scope.row)"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="1"
                    :on-exceed="handleExceed"
                    :data="{
                      imei: scope.row.imei,
                      vin: scope.row.vin,
                      onlineStatus: scope.row.onlineStatus
                    }"
                    :file-list="fileList">
<!--                  <el-button size="small" type="primary">ID导入</el-button>-->
                  <a class="upload-text" slot="trigger">ID导入</a>
                </el-upload>

              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="查看">
              <template slot-scope="scope">
                <a class="remote-id-configuration" slot="trigger" @click="viewRemoteIdConfigurationList(scope.row)">远程ID配置</a>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="formQuery.currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="formQuery.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
          </div>
          <el-dialog
              title="ID配置列表"
              :visible.sync="dialogIdConfigrationListVisible"
              width="30%"
              :before-close="handleClose">
            <el-row>
              <el-col>
                <div>
                  <span style="font-size: 15px;">新建ID：</span>
                  <el-input v-model="newId" size="mini" placeholder="输入" @keydown.down="addId()" style="flex-direction: row;width: 55%" ></el-input>
                  <el-button type="primary" @click="addId()" size="mini" style="margin-left: 3%">新建</el-button>
                </div>
              </el-col>
            </el-row>
            <el-table
                :data="idConfigrationTable"
                style="width: 100%">
              <el-table-column
                  prop="id"
                  label="id">
              </el-table-column>
              <el-table-column
                  align="center"
                  label="操作">
                <template slot-scope="scope">
                  <el-popconfirm
                      confirm-button-text='是'
                      cancel-button-text='否'
                      icon="el-icon-info"
                      icon-color="red"
                      title="确定删除这个ID吗？"
                      @confirm="delId(scope.$index, scope.row)"
                  >
                    <el-button slot="reference" type="danger"  size="mini">删除</el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogIdConfigrationListVisible = false">取 消</el-button>
              <el-button type="primary" @click="updateIds()">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </el-card>
    </div>

  </div>
</template>

<script>
import {uploadExcel, downloadModal, getIds,setIds} from "../../common/idConfugurationManagement.js";
import {exportFile} from "../../utils/utils";
import fa from "element-ui/src/locale/lang/fa";
import {getVehicleList} from "@/common/dataReportingApi";
export default {
  name: "IdConfugurationManagement",
  props: {
  },
  data() {
    return {
      total: 0,
      formQuery: {
        currentPage: 1,
        pageSize: 10,
        vin: '',
        terminalImei: '',
        terminalWorkStatus: ''
      },
      terminalWorkStatusList: [
        {
          value: '0',
          label: '离线'
        },
        {
          value: '1',
          label: '在线'
        }
      ],
      onlineStatusObj: {
        0: '离线',
        1: '在线',
      },
      tableData: [],
      newId: '',
      setVin: '',
      dialogIdConfigrationListVisible: false,
      dialogNewIdVisible: false,
      idConfigrationTable: [],
      fileList: []
    }
  },
  created() {
  },
  mounted() {
    this.initTable();
  },
  destroyed() {
  },
  methods: {
    // 获取列表
    async initTable() {
      this.tableLoadingType = true
      try {
        const param = {
          pageNo: this.formQuery.currentPage,
          pageSize: this.formQuery.pageSize,
          vin: this.formQuery.vin,
          onlineStatus: this.formQuery.terminalWorkStatus
        }
        const res = await getVehicleList(param)
        console.log(res)
        if (res.code === 200) {
          this.tableData = res.data
          this.total = res.total
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          });
          this.tableLoadingType = false
        }
      } catch (e) {
        this.tableLoadingType = false
        console.log(e)
      }
    },
    getIndex(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    },
    handleClose() {
      this.dialogIdConfigrationListVisible = false
    },
    uploadExcelFile(params) {
      const file = params.file;
      const imei = params.data.imei; // 从参数中获取 IMEI 号码
      const vin = params.data.vin; // 从参数中获取 vin 号码
      console.log("file.name:::", file.name);
      console.log("imei:::", vin); // 输出 IMEI 号码
      console.log("vin:::", vin); // 输出 IMEI 号码
      // 根据后台需求数据格式
      const form = new FormData();
      // 文件对象
      form.append('file', file);
      form.append('imei', vin); // 将动态获取的 IMEI 号码添加到表单数据中
      console.log("form:::", form);
      uploadExcel(form).then(res=>{
        console.log("res::",res)
        this.$notify.success({
          title: '成功提示',
          message: 'ID导入成功!!!!'
        })
      }).catch(err=>{
        console.log(err)
      })
      this.fileList = []
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    beforeUpload(file,row) {
      console.log("row::",row)
        let onlineStatus = row.onlineStatus;
        if (onlineStatus === 0) {
          alert("终端未上线，请稍后再试！！！")
          return false;
        }

      console.log("file",file)
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      console.log(testmsg)
      const extension1 = testmsg === 'xlsx' || testmsg === 'xls'
      if (
          !extension1
      ) {
        this.$notify.error({
          title: '错误提示',
          message: '上传文件只能是.xlsx/.xls格式!'
        })

        return false
      }
    },
    handlePreview(file) {
      console.log("handlePreview::",file);
    },
    handleExceed(files, fileList) {
      console.log(files)
      var testmsg = files[0].name.substring(files[0].name.lastIndexOf('.') + 1)
      console.log(testmsg)
      const extension1 = testmsg === 'xlsx' || testmsg === 'xls'
      if (
          !extension1
      ) {
        this.$notify.error({
          title: '错误提示',
          message: '上传文件只能是.xlsx/.xls格式!'
        })
        return false
      }
      if (files.length === 1) {
        this.$notify.error({
          title: '错误提示',
          message: '当前限制选择 1 个文件!'
        })
        return false
      }
      // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {


    },
    viewRemoteIdConfigurationList(row) {

      this.dialogIdConfigrationListVisible = true
      let imei = row.imei
      let vin = row.vin
      this.setVin = vin
      let params = {
        imei: vin
      }
      getIds(params).then(res => {
        console.log("res::",res)
        let data = res.data ? res.data : []
        this.idConfigrationTable = data.map(item => ({ id: item.toString() }));
      })
    },
    addId(){
      if (!this.newId){
        this.$message({
          message: 'id不能为空！！！',
          type: 'warning'
        });
        return;
      }
      this.idConfigrationTable.unshift({id: this.newId})
      this.newId = ''
      this.$message({
        message: 'id添加成功喽！',
        type: 'success'
      });

    },
    delId(index,row){
      console.log("delIndex::",index)
      console.log("delRow:::",row)
      if (index >= 0 && index < this.idConfigrationTable.length) {
        this.idConfigrationTable.splice(index, 1); // 删除指定索引的元素
      }
    },
    updateIds(){
      let ids = this.idConfigrationTable.map(item => item.id);
      if (ids.length === 0){
        this.$notify.error({
          title: '错误提示',
          message: 'id必须保留一个!!'
        });
        return;
      }
      let vin = this.setVin
      let params = {
        ids: ids,
        imei: vin
      }
      console.log("params::",params)

      setIds(params).then(res => {
        console.log("res::::",res.msg)
        console.log(res)
        if (res.code === 200 && res.data === 1) {
          this.$notify.success({
            message: '成功'
          });
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          });
          this.tableLoadingType = false
        }
      })

      this.dialogIdConfigrationListVisible = false

    },
    checkCarOnline(){
      return true;
    },
    search() {
      this.formQuery.currentPage = 1
      this.formQuery.pageSize = 10
      this.initTable()
    },
    reset() {
      this.formQuery = {
        currentPage: 1,
        pageSize: 10,
        terminalImei: '',
        terminalWorkStatus: ''
      }
      this.initTable()
    },
    templateDownload(){
      downloadModal().then(res=>{
        console.log(res)
        let fileNames = res.headers['content-disposition'] //获取到Content-Disposition;filename
        let regFileNames = fileNames.match(/=(.*)$/)[1]; //文件名称  截取=后面的文件名称
        console.log("res.data:::",res.data)
        if (res.data) {
          exportFile(res.data, decodeURI(regFileNames,'utf-8'))
        } else {
          this.$notify.error({
            title: '错误提示',
            message: '导出数据失败 !'
          })
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    handleSizeChange(e) {
      this.formQuery.pageSize = e
      this.initTable()
    },
    handleCurrentChange(e) {
      this.formQuery.currentPage = e
      this.initTable()
    },
    handleSelectionChange() {
    }
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 10px;
  text-align: right;
}

.father-box {
  height: 98%;
}






.padding-box {
  height: 90%;
  background: #ffffff !important;
  text-align: left;
  padding: 0 20px;
}


.top-card {
  height: 100%;
  border-radius: 10px;

}

.car-box {
  height: 10%;
  text-align: left;
  border-radius: 10px;
  padding: 20px 30px;
}
.upload-text{
  color: blue;
}
.remote-id-configuration{
  color: blue;
}
</style>
